export default __webpack_public_path__ + "static/media/me.77addf2c.jpg";